import { get } from "lodash-es";
import { postDrafts } from "../../apis/drafts";
import { getApprobalListByParam } from "../../utils/approval";

const getTask = async ({ mode, defaultData }) => {
  const getTitle = () => {
    return `기안 건의`;
  };
  const fields = [
    {
      title: ' ',
      type: 'button',
      label: '상세 내용 입력',
      isHide: ({ form }) => mode !== 'create' || form.detailOptions,
      className: "full-width ",
      color: 'gray-line',
      onClick: ({ onChange }) => {
        if (onChange) {
          onChange({ target: { name: 'detailOptions', value: true } })
        }
      },
    },
    
    {
      title: "문서번호",
      key: "docNumber",
      isHide: ({ form }) => {
        if (form.detailOptions) return false
        return !form.docNumber
      },
      type: "input",
    },
    {
      title: "처리기간",
      key: "processingPeriod",
      isHide: ({ form }) => {
        if (form.detailOptions) return false
        return !form.processingPeriod
      },
      type: "input",
    },
    {
      title: "시행일자",
      key: "effectiveDate",
      isHide: ({ form }) => {
        if (form.detailOptions) return false
        return !form.effectiveDate
      },
      type: "input",
    },
    {
      title: "보존년한",
      key: "retentionYear",
      isHide: ({ form }) => {
        if (form.detailOptions) return false
        return !form.retentionYear
      },
      type: "input",
    },
    {
      title: "경유",
      key: "through",
      isHide: ({ form }) => {
        if (form.detailOptions) return false
        return !form.through
      },
      type: "input",
    },
    {
      title: "수신",
      key: "receive",
      isHide: ({ form }) => {
        if (form.detailOptions) return false
        return !form.receive
      },
      type: "input",
    },
    {
      title: "참조",
      key: "refer",
      isHide: ({ form }) => {
        if (form.detailOptions) return false
        return !form.refer
      },
      type: "input",
    },
    {
      title: "지시사항",
      key: "instructions",
      isHide: ({ form }) => {
        if (form.detailOptions) return false
        return !form.instructions
      },
      type: "input",
    },
    {
      title: "제목",
      key: "title",
      type: "input",
      required: true,
    },
    {
      title: "기안내용",
      key: "content",
      type: "editor",
      required: true,
      height: "300px"
    },
    {
      title: "첨부파일",
      key: "uploadFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
  ];

  const defaultForm = {
    title: get(defaultData, 'data.draft.title', getTitle()),
    content: get(defaultData, 'data.draft.content', ""),
    uploadFiles: get(defaultData, 'data.draft.uploadFiles', []),
    docNumber: get(defaultData, 'data.draft.docNumber', ""),
    processingPeriod: get(defaultData, 'data.draft.processingPeriod', ""),
    effectiveDate: get(defaultData, 'data.draft.effectiveDate', ""),
    retentionYear: get(defaultData, 'data.draft.retentionYear', ""),
    through: get(defaultData, 'data.draft.through', ""),
    receive: get(defaultData, 'data.draft.receive', ""),
    refer: get(defaultData, 'data.draft.refer', ""),
    instructions: get(defaultData, 'data.draft.instructions', ""),
  };

  const create = (form) => {
    const params = {
      title: form.title,
      content: form.content,
      docNumber: form.docNumber,
      processingPeriod: form.processingPeriod,
      effectiveDate: form.effectiveDate,
      retentionYear: form.retentionYear,
      through: form.through,
      receive: form.receive,
      refer: form.refer,
      instructions: form.instructions,
      type: "common_draft",
      uploadFiles: form.uploadFiles,
      approvals: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
    };

    return postDrafts(params);
  };
  const validate = (form) => {
    let errors = {};
    return errors;
  };
  return {
    fields, defaultForm, create, validate
  };
};

export default getTask;